module.exports = __webpack_public_path__ + "static/media/plan-choose-icon.3c52f513.svg";